import Lock from "@/models/Lock";
import objectLockWebSocket from "@/utils/objectLockWebSocket";

const state = {
	lockInfo: null, // lockしているオブジェクト
};

const mutations = {
	setLockStatus(state, { objId, status, failed = false }) {
		if (status) {
			// ロック取得
			const lockObject = new Lock(objId);
			lockObject.failed = failed;
			// Keep the keep-alive handle on the same object so stopLockUpdate can still clear it
			if (state.lockInfo?.objId === objId) {
				lockObject.intervalId = state.lockInfo.intervalId;
			}
			state.lockInfo = lockObject;
		} else {
			// ロック解放
			state.lockInfo = null;
		}
	},
	updateLockStatus(state, object) {
		for (const key of Object.keys(object)) {
			state.lockInfo[key] = object[key];
		}
	},
};

const actions = {
	/** ロック取得 */
	attemptLock({ state, commit }, objId) {
		if (state.lockInfo?.objId === objId && !state.lockInfo.failed) {
			// objIdに変更がない場合はロックの取得ではなく継続リクエストのためロック情報を変更しない
			// A success after a failed attempt on the same object is a new lock, not a keep-alive
			return;
		}
		commit("setLockStatus", { objId, status: true });
	},
	/** ロック解放 */
	releaseLock({ commit }) {
		commit("setLockStatus", { status: false });
	},
	/** ロック失敗 */
	lockFailed({ commit }, objId) {
		commit("setLockStatus", { objId, status: true, failed: true });
	},
	/** ロック更新 */
	keepLock({ state, commit }) {
		const intervalId = setInterval(() => {
			// 5秒に1回ロック情報を更新する。ループ中にロックが解放される可能性があるためリクエストを投げる前にロック情報の有無をチェックする
			if (state.lockInfo) {
				objectLockWebSocket.sendLockEvent(state.lockInfo.objId);
			}
		}, 5000);
		commit("updateLockStatus", { intervalId });
	},
	/** ロック更新停止 */
	stopLockUpdate({ state, commit }) {
		clearInterval(state.lockInfo.intervalId);
		commit("updateLockStatus", { intervalId: null });
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
};
